import {DEBUG} from '../FacebookBusiness';

export const dataLayerPush = (data) => {
  if (DEBUG) {
    console.table(data);
  } else {
    window.dataLayer.push(data);
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/dataLayerPush.js